import loadable from '@loadable/component';

export const LoadableNavBarMobile = loadable(() => import('./NavBarMobile'));
